<template>
  <v-container fluid>
    <!-- Table of Contents -->
    <v-card class="mb-5 pb-3">
      <v-toolbar color="primary" dark>
        Table of Contents 
        <v-spacer></v-spacer>
        <v-switch
        class="ma-2"
        style="position: relative; top: 10px"
        v-if="apiUrl != 'https://api.flexi-comms.com'"
        v-model="apiUrlSelection"
        :label="`${apiUrlSelection ? 'Dev Site' : 'Live Site'}`"
        ></v-switch>
      </v-toolbar>
      <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
      <v-card-text>
        <v-treeview
          v-model="tree"
          v-if="currentUserData.role == 'superAdmin'"
          :open="open"
          :items="itemsAdmin"
          activatable
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item }">
            <!-- <v-icon v-if="!item.icon">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon> -->
            <v-icon
              v-if="!item.link && (item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin'))"
            >{{ item.icon }}</v-icon>
            <v-icon
              v-else-if="item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin')"
              @click="$vuetify.goTo(item.link, options); console.log(item.link)"
            >{{ item.icon }}</v-icon>
          </template>
          <template v-slot:label="{ item }">
            <!-- <v-icon v-if="!item.icon">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon> -->
            <div
              v-if="!item.link && (item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin'))"
            >{{ item.name }}</div>
            <div
              v-else-if="item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin')"
              @click="$vuetify.goTo(item.link, options); console.log(item.link)"
            >{{ item.name }}</div>
          </template>
        </v-treeview>
        <v-treeview
          v-model="tree"
          v-else
          :open="open"
          :items="items"
          activatable
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item }">
            <!-- <v-icon v-if="!item.icon">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon> -->
            <v-icon
              v-if="!item.link && (item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin'))"
            >{{ item.icon }}</v-icon>
            <v-icon
              v-else-if="item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin')"
              @click="$vuetify.goTo(item.link, options); console.log(item.link)"
            >{{ item.icon }}</v-icon>
          </template>
          <template v-slot:label="{ item }">
            <!-- <v-icon v-if="!item.icon">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon> -->
            <div
              v-if="!item.link && (item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin'))"
            >{{ item.name }}</div>
            <div
              v-else-if="item.admin == false || (item.admin == true && currentUserData.role == 'superAdmin')"
              @click="$vuetify.goTo(item.link, options); console.log(item.link)"
            >{{ item.name }}</div>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
    <!-- Device Specs -->
    <v-card class="mb-5 pb-3">
      <v-toolbar color="primary" dark>Device Specs</v-toolbar>
      <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
      <v-card-text>
        <h2 id="deviceCreation">Creating a Device</h2>
        <p>
          Devices on the System are created by Application Admins. On the Devices page, you need to click on the "New" button on the tool-bar.
          When the Dialog has appeared, you need to fill out the information accordingly.
        </p>
        <h2 id="deviceManagement">Managing the Device</h2>
        <p>
          To manage a device you can either click on the action menu to the left, or double click on the row. This will bring up a menu of options.
          In this menu you will be able to edit certain information for the Device. This information does not need to be stored on the device.
        </p>
        <h2>Regenerating the Device Key</h2>
        <p>
          To regenerate the device key you are going to need to open the Action Menu by either clicking on the action menu to the left, or double
          clicking the row of the device. Once in the menu, you should see a button to "Key Regen". Clicking on this and then clicking on Continue
          will generate a new Key for the device. After this, you must update the Key manually on your device, as the old
          Key will be invalid.
        </p>
        <h2 id="deviceComSpec">ID and K</h2>
        <p>
          On device creation you will be given a device_id which you will add into the device as ID, this has to be sent with every request to the API.
          You will also be given k, which is the Device Key that was generated for your device, this will also need to be sent with every request to the API.
        </p>
        <h2>Endpoint to create event</h2>
        <p>
          <span v-if="currentUserData.role == 'superAdmin'">
            <span style="font-weight: 700">Dev Site URL:</span> <pre>https://flexi-comms-api.simplesoft.co.nz/events</pre> 
          </span>
          <br />
          <span style="font-weight: 700">
            <span v-if="currentUserData.role == 'superAdmin'">Live Site</span> URL:
          </span> <pre>https://api.flexi-comms.com/events</pre> 
          <br />
          <span style="font-weight: 700">Method:</span> POST
          <br />Data is to be sent through as JSON in the Body
        </p>
        <h2>Data Format to be sent to API</h2>
        <p>
          The data to be sent to the API must be sent in JSON. All fields that are sent through, that are not part of the JSON demonstration below
          will be added to an Extended Data Field. The required fields are id, type.
        </p>
        <vue-json-pretty :data="eventDataFormat" :highlightMouseoverNode="true" :showLength="true"></vue-json-pretty>
        <p>The Response from the server if successful</p>
        <vue-json-pretty
          :data="{'Result': 'Success', 'events_id': '1111'}"
          :highlightMouseoverNode="true"
          :showLength="true"
        ></vue-json-pretty>
      </v-card-text>
    </v-card>
    <!-- Event Specs -->
    <v-card class="mb-5 pb-3">
      <v-toolbar color="primary" dark>Event Specs</v-toolbar>
      <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
      <v-card-text>
        <h2 id="eventDataWebsite">Event data (Via Website)</h2>
        <p>
          To view event data via the website, you need to click on the events drop down and then select either "All Events" or "Trigger Events".
          <br />All events will have a table with all of the events in the current Date range which is set in the toolbar.
          <br />Trigger events will have the files that were sent through with the events that have their status set to "trigger".
        </p>
        <div v-if="currentUserData.role == 'superAdmin'">
          <h2 id="eventDataAPI">Event data (Via API)</h2>
          <p>
            This is currently only available for Super Admins. To access the event data via the API, you must have your API Key, and the App ID.
            <br />The Api Key is a randomly generated GUID that identifies a User, So this must be kept Secret. At this time API Keys are Generated manually
            by the Developers, but a system to have this generated automatically is underway.
            <br />The App ID is the ID of the application in which you are requesting the data for, If your are a Super Admin, this is Bypassed but an App ID
            will still need to be sent through (e.g. 10)
            <br />The API Key and APP ID will both need to be sent through in the headers. The Keys for the Headers are Apikey, Appid.
            <br />You also need to send through a date range as parameters on the end of the URL. The format for this is as Follows
            <br />
            <br /> <pre>dateRange[]=2020-08-14&dateRange[]=2020-07-15</pre> 
            <br />Optionally you can also send through the type as a Parameter e.g. type=trigger.
            <br />
            <br />The URL for the endpoint is The same as creating an Event, but instead using the GET Method
            <br />A full endpoint for trigger events withing a specific Date Range would be
            <br />
            <pre>{{apiUrlSelection ? apiUrl : 'https://api.flexi-comms.com'}}/events?dateRange[]=2020-08-14&dateRange[]=2020-07-15&type=trigger</pre> 
          </p>
        </div>
        <div v-if="currentUserData.role == 'superAdmin'">
          <h2 id="eventImagesFromS3">Event Images</h2>
          <p>
            If you have gotten the event data from the API, to be able to get the Images, you will need to request them from S3.
            To do this you will need to need to generate the Url to get these images. The URL is made up of three peices, the S3 bucket, 
            event ID and the file extension. The code example should look like this
            <br> 
            <pre>https://{bucket}.s3.ap-southeast-2.amazonaws.com/{event.id}-triggerEvent.{event.imageType}</pre>
            <br> 
            An example of a functioning URL will look like this 
            <pre>https://flexi-comms-trigger-events.s3.ap-southeast-2.amazonaws.com/27612-triggerEvent.jpg</pre>
          </p>
        </div>
        <div v-if="currentUserData.role == 'superAdmin'">
          <h2 id="eventMetaData">Creating Meta Data for an Event (Via API)</h2>
          <p>
            The API Call uses the same concept of Api Key and App ID stated above in Event Data (Via API).
            No Parameters need to be sent with the API Call, All that needs to be sent through is the "id" in the Body data, and what ever
            other data you wish to be put into the Meta Data.
            <br />The data needs to be in JSON format, and sent through in the Body, and the Api Key + App ID needs to also be sent through in the header
            <br />The Endpoint to send the request to is the same as creating an Event, but instead using the PUT Method.
            <br />All Data that is sent through will be put into the Meta Data field for the Event exactly how it is sent through.
            <br />
            <br />An example of what to send through
          </p>
          <vue-json-pretty
            :data="eventMetaDataFormat"
            :highlightMouseoverNode="true"
            :showLength="true"
          ></vue-json-pretty>
          <p>An example of a successful response</p>
          <vue-json-pretty
            :data="{'Result': 'Success'}"
            :highlightMouseoverNode="true"
            :showLength="true"
          ></vue-json-pretty>
        </div>
      </v-card-text>
    </v-card>
    <!-- AWS Specs -->
    <v-card v-if="currentUserData.role == 'superAdmin'" class="mb-5 pb-3">
      <v-toolbar color="primary" dark>AWS Specs</v-toolbar>
      <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeviceDialog = true" /> -->
      <v-card-text>
        <h2 id="awsInstallation">AWS CLI Installation</h2>
        <p>
          Aws has their CLI installation process well Documented, To view it
          <a
            target="_blank"
            href="https://docs.aws.amazon.com/cli/latest/userguide/cli-chap-install.html"
          >click here</a>
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import VueJsonPretty from "vue-json-pretty";
  import expandedToolbar from "@/components/expandedToolbar.vue";

  export default {
    components: { AppBar, VueJsonPretty, expandedToolbar },
    computed: {
      ...mapGetters(["currentUser", "currentUserData", "apiUrl"]),
    },
    data: () => ({
      drawer: null,
      apiUrlSelection: true,
      // Scroll Options
      options: {
        duration: 450,
        offset: 0,
        easing: "easeInOutCubic",
      },
      // Table of Contents
      open: [],
      tree: [],
      items: [
        {
          name: "Devices",
          icon: "mdi-cctv",
          admin: false,
          children: [
            {
              name: "Device Creation",
              icon: "mdi-plus",
              admin: false,
              link: "#deviceCreation",
            },
            {
              name: "Device Management",
              icon: "mdi-cogs",
              admin: false,
              link: "#deviceManagement",
            },
            {
              name: "Device Communication Spec",
              icon: "mdi-wifi",
              admin: false,
              link: "#deviceComSpec",
            },
          ],
        },
        {
          name: "Events",
          icon: "mdi-calendar-alert",
          admin: false,
          children: [
            {
              name: "Creating an Event (Device)",
              icon: "mdi-plus",
              admin: false,
              link: "#deviceComSpec",
            },
            {
              name: "Viewing Event Data",
              icon: "mdi-eye",
              admin: false,
              children: [
                {
                  name: "Event data (Via Website)",
                  icon: "mdi-earth",
                  admin: false,
                  link: "#eventDataWebsite",
                },
              ],
            },
          ],
        },
      ],
      itemsAdmin: [
        {
          name: "Devices",
          icon: "mdi-cctv",
          admin: false,
          children: [
            {
              name: "Device Creation",
              icon: "mdi-plus",
              admin: false,
              link: "#deviceCreation",
            },
            {
              name: "Device Management",
              icon: "mdi-cogs",
              admin: false,
              link: "#deviceManagement",
            },
            {
              name: "Device Communication Spec",
              icon: "mdi-wifi",
              admin: false,
              link: "#deviceComSpec",
            },
          ],
        },
        {
          name: "Events",
          icon: "mdi-calendar-alert",
          admin: false,
          children: [
            {
              name: "Creating an Event (Device)",
              icon: "mdi-plus",
              admin: false,
              link: "#deviceComSpec",
            },
            {
              name: "Viewing Event Data",
              icon: "mdi-eye",
              admin: false,
              children: [
                {
                  name: "Event data (Via Website)",
                  icon: "mdi-earth",
                  admin: false,
                  link: "#eventDataWebsite",
                },
                {
                  name: "Event Data (Via API)",
                  icon: "mdi-api",
                  admin: true,
                  link: "#eventDataAPI",
                },
                {
                  name: "Event Images",
                  icon: "mdi-image",
                  admin: true,
                  link: "#eventImagesFromS3",
                },
              ],
            },
            {
              name: "Creating metaData for an Event (Via API)",
              icon: "mdi-update",
              admin: true,
              link: "#eventMetaData",
            },
          ],
        },
        {
          name: "AWS",
          icon: "mdi-aws",
          admin: true,
          children: [
            {
              name: "CLI Installation",
              icon: "mdi-download",
              admin: true,
              link: "#awsInstallation",
            },
          ],
        },
      ],
      // Devices
      eventDataFormat: {
        id: 1,
        k: "Device Key",
        type: "Trigger",
        sessions: 1,
        triggers: 1,
        version: 1,
        battery: 1.3,
        temp: 12.2,
        message: "String",
        time: "UTC Time Stamp",
        image: "Base64 Encoded file (Doesnt need to be an image)",
        ext: "Extention for file. Default: jpg (Doesnt need to be an image)",
      },
      // Events
      eventMetaDataFormat: {
        id: 1,
        exampleData1: "This is example data",
        exampleData2:
          "Both exampleData1 and exampleData2, will be added into the Meta Data field",
      },
    }),
    methods: {},
  };
  window.batteryFormatter = function batteryFormatter(params) {
    if (params.data.battery) {
      return `${params.data.battery}V`;
    } else {
      return "";
    }
  };
  window.temperatureFormatter = function temperatureFormatter(params) {
    if (params.data.temp) {
      return params.data.temp + "°c";
    } else {
      return "";
    }
    return params.data.temp + "°c";
  };
  window.createdAtFormatter = function createdTimeFormatter(params) {
    return moment
      .utc(params.data.created_at)
      .local()
      .format("MMMM Do YYYY, h:mm:ss a");
  };
  window.updatedAtFormatter = function createdTimeFormatter(params) {
    if (params.data.updated_at) {
      return moment
        .utc(params.data.updated_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
